import { component } from "picoapp";

export const basicCollection = component(async (node, ctx) => {
  const { default: Isotope } = await import("isotope-layout");
  const gridSection = node.querySelector("[data-grid]");
  const grid = new Isotope(gridSection, {
    itemSelector: "[data-grid-item]",
    layoutMode: "fitRows",
  });

  grid.on("arrangeComplete", () => {
    ctx.emit("product-card:updateAll");
  });

  grid.on("layoutComplete", () => {
    node.classList.remove("hide-init");
  });

  grid.arrange();
});

export default basicCollection;
